/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ScreenviewCondition from 'cio/app-models/conditions/screenview';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';
import CioConditionViewerBase, { CioConditionViewerBaseArgs } from 'cio/components/cio-condition-viewer-base';

interface CioConditionViewerScreenviewArgs extends CioConditionViewerBaseArgs {
  condition: ScreenviewCondition;
  depth?: number;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
}

export default class CioConditionViewerScreenview extends CioConditionViewerBase<CioConditionViewerScreenviewArgs> {}
